/*
  Global Number Formatter for the app

  Outputs in thousand separated commas  6789054.88 -> 6,789,054.88

  Props:
  value (Input value, 0 default)
  decimals (Number of decimals in the output, 0 default)

  Usage: <NumberFormatter value={company.numberApplicants} decimals="2"/>

  returns in format :  x,xxx.xx
*/
import React, { PureComponent } from 'react';
import { formatStringFloat } from 'util/numberUtil';

class NumberFormatter extends PureComponent {
   render() {
      const { value, decimals, isCurrency, isPercentage } = this.props;
      const numberToFormat = value || 0;
      const formatDecimals = decimals || 0;

      const formatted = formatStringFloat(`${ numberToFormat }`, formatDecimals);

      if (!isCurrency) {
         if (isPercentage) {
            return (
               <>
                  {formatted}%
               </>
            );
         }
         return (
            <>
               {formatted}
            </>
         );
      } else {
         const formattedValue = formatted.replace('-', '');
         const isNegative = parseFloat(numberToFormat.toString()) < 0;
         let formattedCurrency = '';
         if (isNegative) {
            formattedCurrency += '-$';
         } else {
            formattedCurrency += '$';
         }
         formattedCurrency += formattedValue;
         return (
            <>
               {formattedCurrency}
            </>
         );
      }
   }
}

export default NumberFormatter;
